/** Local copy of ticker-detail reveal easings — avoid cross-app imports. */
export const PAGE_REVEAL_EASE = [0.22, 1, 0.36, 1] as const;

/** Slightly snappier settle for the page header “aha”. */
export const HERO_AHA_EASE = [0.16, 1, 0.3, 1] as const;

export const HEADER_REVEAL = {
  duration: 0.58,
  delay: 0.04,
} as const;

export const WEEK_PILLS_REVEAL = {
  duration: 0.42,
  delay: 0.28,
} as const;

/** Mon→Fri stagger on mount (all five days; list is short and usually on-screen). */
export function dayEntranceDelay(sequence: number): number {
  return 0.42 + Math.max(0, sequence) * 0.08;
}

/**
 * Visible company tiles before the “See more” CTA card.
 * Mobile 3-col: 5 tiles + CTA. Desktop 4-col: 7 tiles + CTA.
 */
export const DAY_PREVIEW_LIMIT_MOBILE = 5;
export const DAY_PREVIEW_LIMIT_DESKTOP = 7;
